module.exports = __webpack_public_path__ + "static/media/vanity double bowl front.f65e2066.jpg";